import { callFunction } from "./functions-client";

// Equipment Auctions (LOS Phase 9).
export interface Auction {
  id: string;
  title: string;
  category?: string;
  description?: string | null;
  current_price_cents: number;
  starting_price_cents?: number;
  min_increment_cents?: number;
  bid_count: number;
  ends_at: string;
  status?: string;
  winner_account_id?: string | null;
  seller_account_id?: string;
  seller_name?: string | null;
  selling?: boolean;
}

export interface AuctionBid {
  amount_cents: number;
  created_at: string;
  bidder_account_id: string;
  bidder_name: string | null;
}

export const createAuction = (input: {
  title: string; category?: string; description?: string; starting_price: string; reserve_price?: string; min_increment?: string; ends_in_hours: number;
}) => callFunction<{ auction: Auction }>("auctions/create", { body: input });

export const listAuctions = () =>
  callFunction<{ auctions: Auction[] }>("auctions/list", { method: "GET" });

export const getAuction = (id: string) =>
  callFunction<{ auction: Auction; bids: AuctionBid[]; is_seller: boolean; min_next: number }>(
    `auctions/get?id=${encodeURIComponent(id)}`,
    { method: "GET" },
  );

export const placeBid = (auction_id: string, amount: string) =>
  callFunction<{ ok: boolean; current_price_cents: number; bid_count: number }>("auctions/bid", { body: { auction_id, amount } });

export const closeAuction = (auction_id: string) =>
  callFunction<{ auction: Auction; reserve_met: boolean }>("auctions/close", { body: { auction_id } });

export const myAuctions = () =>
  callFunction<{ auctions: Auction[] }>("auctions/mine", { method: "GET" });

export const auctionPrice = (cents: number) => `$${(cents / 100).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

export function timeLeft(endsAt: string): string {
  const ms = new Date(endsAt).getTime() - Date.now();
  if (ms <= 0) return "Ended";
  const h = Math.floor(ms / 3_600_000);
  const m = Math.floor((ms % 3_600_000) / 60_000);
  if (h >= 24) return `${Math.floor(h / 24)}d ${h % 24}h left`;
  return h > 0 ? `${h}h ${m}m left` : `${m}m left`;
}
